// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { RegisterService } from '../services/RegisterService';
// Models
import { User } from '../models/User';
import { NonAisStudent } from '../models/NonAisStudent';
import { Credential } from '../models/Credential';
import * as moment from 'moment';

@Component({
    selector: 'add-student',
    template: require('./AddStudentComponent.html'),
    styles: [require('./AddStudentComponent.sass')],
})

export class AddStudentComponent implements OnInit {
  credential: Credential;
  message: string;
  messageType: string;
  redirectUrl: string;
  nonAisStudent: NonAisStudent;
  formSubmitted: boolean = false;
  resetField: string;
    
  doctorCareValue: string;
  medicationValue: string;
  allergicValue: string;
  limitsValue: string;
  senValue: string; 
  senSupportValue: string;
    
  constructor(
    private registerService: RegisterService,
    private sessionService: SessionService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.resetField = "";
    this.nonAisStudent = new NonAisStudent();
    // Use Session Service to get session and check if user had already logged in.
  }

  resetMedicalFields() {
    if (this.doctorCareValue === "doctorCareNo") {
      this.nonAisStudent.medical[0].under_doctor_care = ""; 
    }
    if (this.medicationValue === "medicationNo") {
      this.nonAisStudent.medical[0].medication = "";
    }
    if (this.allergicValue === "allergicNo") {
      this.nonAisStudent.medical[0].allergic = "";
    }
    if (this.limitsValue === "limitsNo") {
      this.nonAisStudent.medical[0].limit_paticipation_athlentic = "";
    }
    if (this.senValue === "senNo") {
      this.nonAisStudent.medical[0].special_education_needs = "";
    }
    if (this.senSupportValue === "senSupportNo") {
      this.nonAisStudent.medical[0].special_education_support = "";
    }
  }

    onSubmit() {
    this.resetMedicalFields();
    this.formSubmitted = true;
    // Reset message content
    this.message = "";
    // Post user login data to create session
    this.registerNonAis(this.nonAisStudent);
  }

  /**
   * Get Session from API service to make sure that user had logged in.
   * Update User Data on local storage and redirect to the desired URL
   * if request responses session data.
   * @param none
   * @return none
   */
  private getSession() {
    this.sessionService.getSession().subscribe(
      (user) => {
        this.userService.setUserSessionData(user);
      },
      (error) => {
        //TO DO: Handle any error if needed in the furture
        this.message = "";
        this.messageType = "alert";
      }
    );
  }

  /**
   * Post Session to API service to create new session.
   * Update User Data on local storage and redirect to desired URL
   * if request responses session data.
   * @param {Credential} - user credential input
   * @return none
   */
  private postSession(credential: Credential) {
    this.sessionService.postSession(credential).subscribe(
      (user) => {
        // Set user session data
        this.userService.setUserSessionData(user);

        // Fire user session data changed event
        this.userService.userDataChanged(user);
      },
      (error) => {
        this.formSubmitted = false;
        this.message = "Invalid email address or password.";
        this.messageType = "alert";
      }
    );
  }

  private registerNonAis(nonAisStudent: NonAisStudent) {
    let form: any = Object.assign({}, nonAisStudent);
    form.date_of_birth = moment(form.date_of_birth, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    // console.log(nonAisStudent);
    this.registerService.postNonAisStudent(form).subscribe(
      (complete) => {
        (this.messageType = "success"),
          (this.message = "Adding student successfully");
        this.formSubmitted = false;
        this.router.navigateByUrl('/booking/students');
      },
      (error) => {
        this.formSubmitted = false;
        this.messageType = "alert";
        const msg: any = JSON.parse(error._body);
        if (msg.message == "student wasn't created")
          this.message = "The student already exist in the system";
        else this.message = msg.message;
      }
    );
  }

  resetMedicalField(medicalField: any) {
    medicalField = "";
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/user/student/AddStudentComponent.ts